(() => {
  const root = document.querySelector('[data-bbc-enquiry-root]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  const storageKey = root.dataset.storageKey || 'bbc-enquiry-shortlist-v1';
  const addLabel = root.dataset.addLabel || 'Add to My Collection';
  const addedLabel = root.dataset.addedLabel || 'Selected';
  const drawer = root.querySelector('[data-bbc-enquiry-drawer]');
  const overlay = root.querySelector('.bbc-enquiry-shortlist__overlay');
  const toggle = root.querySelector('[data-bbc-enquiry-toggle]');
  const count = root.querySelector('[data-bbc-enquiry-count]');
  const empty = root.querySelector('[data-bbc-enquiry-empty]');
  const itemsList = root.querySelector('[data-bbc-enquiry-items]');
  const footer = root.querySelector('[data-bbc-enquiry-footer]');
  const liveRegion = root.querySelector('[data-bbc-enquiry-live]');
  let lastFocused = null;
  let items = [];
  let hadSelectedItems = false;
  let confirmationTimer = null;

  // A small, non-modal confirmation replaces opening the collection drawer on every add.
  const confirmationStyle = document.createElement('style');
  confirmationStyle.textContent = `
    .bbc-enquiry-confirmation[hidden] { display: none !important; }
    .bbc-enquiry-confirmation {
      position: fixed;
      right: clamp(.75rem, 2.5vw, 2rem);
      bottom: calc(5.4rem + env(safe-area-inset-bottom, 0px));
      z-index: 60;
      display: inline-flex;
      align-items: center;
      gap: .55rem;
      max-width: min(23rem, calc(100vw - 1.5rem));
      padding: .75rem 1rem;
      border: 1px solid rgba(205, 167, 89, .75);
      border-radius: 999px;
      background: #0d1b2c;
      box-shadow: 0 8px 28px rgba(9, 20, 34, .18);
      color: #fffdf8;
      font: inherit;
      font-size: .8rem;
      font-weight: 700;
      line-height: 1.3;
      pointer-events: none;
    }
    .bbc-enquiry-confirmation svg { width: 1.1rem; height: 1.1rem; flex: 0 0 auto; color: #e9c678; }
    @media (max-width: 749px) {
      .bbc-enquiry-confirmation { right: .75rem; bottom: calc(5rem + env(safe-area-inset-bottom, 0px)); padding: .65rem .85rem; }
    }
  `;
  document.head.appendChild(confirmationStyle);
  const confirmation = document.createElement('div');
  confirmation.className = 'bbc-enquiry-confirmation';
  confirmation.hidden = true;
  confirmation.setAttribute('role', 'status');
  confirmation.setAttribute('aria-live', 'polite');
  const confirmationIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  confirmationIcon.setAttribute('viewBox', '0 0 24 24');
  confirmationIcon.setAttribute('fill', 'none');
  confirmationIcon.setAttribute('stroke', 'currentColor');
  confirmationIcon.setAttribute('stroke-width', '2.25');
  confirmationIcon.setAttribute('stroke-linecap', 'round');
  confirmationIcon.setAttribute('stroke-linejoin', 'round');
  confirmationIcon.setAttribute('aria-hidden', 'true');
  const checkmark = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  checkmark.setAttribute('d', 'M5 12.5 10 17l9-10');
  confirmationIcon.appendChild(checkmark);
  const confirmationText = document.createElement('span');
  confirmation.append(confirmationIcon, confirmationText);
  document.body.appendChild(confirmation);

  const showConfirmation = (message) => {
    window.clearTimeout(confirmationTimer);
    confirmationText.textContent = message;
    confirmation.hidden = false;
    confirmationTimer = window.setTimeout(() => {
      confirmation.hidden = true;
      confirmationText.textContent = '';
    }, 2000);
  };

  const readItems = () => {
    try {
      const stored = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(stored)
        ? stored.slice(0, 30).map((item) => ({
            ...item,
            quantity: Number(item.quantity) > 0 ? Math.round(Number(item.quantity)) : 1
          }))
        : [];
    } catch (error) {
      return [];
    }
  };

  const saveItems = () => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(items));
    } catch (error) {
      // Keep the current-page collection usable when persistent storage is unavailable.
    }
  };

  const announce = (message) => {
    if (!liveRegion) return;
    liveRegion.textContent = '';
    window.requestAnimationFrame(() => { liveRegion.textContent = message; });
  };

  const itemKey = (item) => String(item.variantId || item.productId || '');

  const buttonItem = (button) => ({
    productId: button.dataset.productId || '',
    title: button.dataset.productTitle || 'Selected product',
    url: button.dataset.productUrl || '',
    image: button.dataset.productImage || '',
    variantId: button.dataset.variantId || '',
    variantTitle: button.dataset.variantTitle || '',
    quantity: 1
  });

  const formatItem = (item, index) => {
    const variant = item.variantTitle ? `, ${item.variantTitle}` : '';
    const quantity = Number(item.quantity) > 0 ? Math.round(Number(item.quantity)) : 1;
    return `${index + 1}. ${item.title}${variant} — Qty ${quantity}`;
  };

  const syncQuoteForm = () => {
    const quoteInput = document.querySelector('[data-quote-shortlist-input]');
    const legacyInput = document.querySelector('[data-quote-product-input]');
    const summaryPanel = document.querySelector('[data-quote-product]');
    const scheduleContainer = document.querySelector('[data-quote-product-schedule]');
    const fallbackFields = document.querySelector('[data-quote-fallback-fields]');
    const formatted = items.map(formatItem).join('\n');
    const hasItems = items.length > 0;

    if (quoteInput) quoteInput.value = formatted;
    if (hasItems) {
      hadSelectedItems = true;
      if (legacyInput) legacyInput.value = formatted;
      if (summaryPanel) summaryPanel.hidden = true;
    } else if (hadSelectedItems) {
      if (legacyInput) legacyInput.value = '';
      if (summaryPanel) summaryPanel.hidden = true;
    }
    if (scheduleContainer) scheduleContainer.hidden = !hasItems;
    if (fallbackFields) {
      fallbackFields.hidden = hasItems;
      // CSS hiding alone does not exclude inputs from native HTML form posts.
      // Omit *all* manual fallback fields while individual products are selected,
      // but preserve their entered values if the customer later clears the list.
      fallbackFields.querySelectorAll('input, select, textarea').forEach((field) => {
        field.disabled = hasItems;
      });
    }
  };

  const createScheduleItemElement = (item) => {
    const key = itemKey(item);
    const li = document.createElement('li');
    li.className = 'bbc-quote__schedule-item';

    if (item.image) {
      const image = document.createElement('img');
      image.className = 'bbc-quote__schedule-image';
      image.src = item.image;
      image.alt = '';
      image.loading = 'lazy';
      li.appendChild(image);
    } else {
      const placeholder = document.createElement('span');
      placeholder.className = 'bbc-quote__schedule-image';
      placeholder.setAttribute('aria-hidden', 'true');
      li.appendChild(placeholder);
    }

    const copy = document.createElement('div');
    copy.className = 'bbc-quote__schedule-copy';

    const title = document.createElement('p');
    title.className = 'bbc-quote__schedule-title';
    title.textContent = item.title;
    copy.appendChild(title);

    if (item.variantTitle) {
      const variant = document.createElement('p');
      variant.className = 'bbc-quote__schedule-variant';
      variant.textContent = item.variantTitle;
      copy.appendChild(variant);
    }

    const qtyLabel = document.createElement('label');
    qtyLabel.className = 'bbc-quote__schedule-qty';
    const qtySpan = document.createElement('span');
    qtySpan.textContent = 'Quantity';
    const qtyInput = document.createElement('input');
    qtyInput.type = 'number';
    qtyInput.min = '1';
    qtyInput.step = '1';
    qtyInput.inputMode = 'numeric';
    qtyInput.value = String(item.quantity || 1);
    qtyInput.setAttribute('data-quote-schedule-qty', '');
    qtyInput.setAttribute('aria-label', `Quantity for ${item.title}`);
    qtyInput.dataset.key = key;
    qtyLabel.append(qtySpan, qtyInput);
    copy.appendChild(qtyLabel);
    li.appendChild(copy);

    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'bbc-quote__schedule-remove';
    remove.textContent = 'Remove';
    remove.dataset.bbcEnquiryRemove = key;
    remove.setAttribute('aria-label', `Remove ${item.title} from My Collection`);
    li.appendChild(remove);
    return li;
  };

  const renderScheduleList = () => {
    const scheduleList = document.querySelector('[data-quote-schedule-list]');
    if (scheduleList) scheduleList.replaceChildren(...items.map(createScheduleItemElement));
  };

  const syncButtons = () => {
    document.querySelectorAll('[data-bbc-enquiry-add]').forEach((button) => {
      const current = buttonItem(button);
      const isAdded = items.some((item) => itemKey(item) === itemKey(current));
      button.setAttribute('aria-pressed', String(isAdded));
      const label = button.querySelector('[data-bbc-enquiry-add-label]');
      if (label) label.textContent = isAdded ? addedLabel : addLabel;
    });
  };

  const createItemElement = (item) => {
    const li = document.createElement('li');
    li.className = 'bbc-enquiry-shortlist__item';

    if (item.image) {
      const image = document.createElement('img');
      image.className = 'bbc-enquiry-shortlist__image';
      image.src = item.image;
      image.alt = '';
      image.loading = 'lazy';
      li.appendChild(image);
    } else {
      const placeholder = document.createElement('span');
      placeholder.className = 'bbc-enquiry-shortlist__image';
      placeholder.setAttribute('aria-hidden', 'true');
      li.appendChild(placeholder);
    }

    const copy = document.createElement('div');
    copy.className = 'bbc-enquiry-shortlist__item-copy';
    const title = document.createElement(item.url ? 'a' : 'span');
    title.className = 'bbc-enquiry-shortlist__item-title';
    title.textContent = item.title;
    if (item.url) title.href = item.url;
    copy.appendChild(title);

    if (item.variantTitle) {
      const variant = document.createElement('p');
      variant.className = 'bbc-enquiry-shortlist__variant';
      variant.textContent = item.variantTitle;
      copy.appendChild(variant);
    }
    li.appendChild(copy);

    const remove = document.createElement('button');
    remove.className = 'bbc-enquiry-shortlist__remove';
    remove.type = 'button';
    remove.textContent = 'Remove';
    remove.dataset.bbcEnquiryRemove = itemKey(item);
    remove.setAttribute('aria-label', `Remove ${item.title} from My Collection`);
    li.appendChild(remove);
    return li;
  };

  const render = () => {
    if (count) {
      count.textContent = String(items.length);
      count.setAttribute('aria-label', `${items.length} selected ${items.length === 1 ? 'product' : 'products'}`);
    }
    if (itemsList) {
      itemsList.replaceChildren(...items.map(createItemElement));
      itemsList.hidden = items.length === 0;
    }
    if (empty) empty.hidden = items.length > 0;
    if (footer) footer.hidden = items.length === 0;
    syncButtons();
    renderScheduleList();
    syncQuoteForm();
  };

  const openDrawer = () => {
    if (!drawer || !overlay || !toggle) return;
    lastFocused = document.activeElement;
    drawer.hidden = false;
    overlay.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('bbc-enquiry-is-open');
    drawer.querySelector('[data-bbc-enquiry-close]')?.focus();
  };

  const closeDrawer = () => {
    if (!drawer || !overlay || !toggle) return;
    drawer.hidden = true;
    overlay.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('bbc-enquiry-is-open');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  };

  const addItem = (button) => {
    const item = buttonItem(button);
    const key = itemKey(item);
    if (!key) return;
    if (!items.some((candidate) => itemKey(candidate) === key)) {
      items.push(item);
      saveItems();
      render();
      announce(`${item.title} added to My Collection.`);
      showConfirmation('✓ Added to Collection');
    } else {
      announce(`${item.title} is already in My Collection.`);
      showConfirmation('Already in Collection');
    }
    // The customer keeps browsing; the drawer opens only via the Collection toggle.
  };

  const removeItem = (key) => {
    const removed = items.find((item) => itemKey(item) === key);
    items = items.filter((item) => itemKey(item) !== key);
    saveItems();
    render();
    if (removed) announce(`${removed.title} removed from My Collection.`);
  };

  document.addEventListener('click', (event) => {
    const toggleButton = event.target.closest('[data-bbc-enquiry-toggle]');
    if (toggleButton) {
      event.preventDefault();
      event.stopPropagation();
      openDrawer();
      return;
    }

    const closeButton = event.target.closest('[data-bbc-enquiry-close]');
    if (closeButton) {
      event.preventDefault();
      event.stopPropagation();
      closeDrawer();
      return;
    }

    const clearButton = event.target.closest('[data-bbc-enquiry-clear]');
    if (clearButton) {
      event.preventDefault();
      event.stopPropagation();
      items = [];
      saveItems();
      render();
      announce('All products removed from My Collection.');
      return;
    }

    const addButton = event.target.closest('[data-bbc-enquiry-add]');
    if (addButton) {
      event.preventDefault();
      event.stopPropagation();
      addItem(addButton);
      return;
    }

    const removeButton = event.target.closest('[data-bbc-enquiry-remove]');
    if (removeButton) removeItem(removeButton.dataset.bbcEnquiryRemove || '');
  }, true);

  document.addEventListener('input', (event) => {
    const qtyInput = event.target.closest('[data-quote-schedule-qty]');
    if (!qtyInput) return;
    const match = items.find((item) => itemKey(item) === (qtyInput.dataset.key || ''));
    if (!match) return;
    const parsed = parseInt(qtyInput.value, 10);
    match.quantity = Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
    saveItems();
    syncQuoteForm();
  });

  document.addEventListener('change', (event) => {
    const qtyInput = event.target.closest('[data-quote-schedule-qty]');
    if (!qtyInput) return;
    const match = items.find((item) => itemKey(item) === (qtyInput.dataset.key || ''));
    if (match) qtyInput.value = String(match.quantity || 1);
  });

  document.addEventListener('keydown', (event) => {
    if (!drawer || drawer.hidden) return;
    if (event.key === 'Escape') {
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(drawer.querySelectorAll('a[href], button:not([disabled])')).filter((element) => !element.hidden);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.addEventListener('storage', (event) => {
    if (event.key !== storageKey) return;
    items = readItems();
    render();
  });

  // Do not erase a customer's collection merely because Shopify renders success.
  items = readItems();
  render();
})();
